export const inputStyle = {
  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
  borderRadius: '6px',
  padding: '8px 12px',
  backgroundColor: '#fff',
};

export const textareaStyle = {
  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
  borderRadius: '6px',
  padding: '5px',
  backgroundColor: '#fff',
  resize: 'none',
};
